import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function ClosingCTA() {
  return (
    <section data-testid="closing-cta-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 pb-20 lg:px-6 lg:pb-28">
        <div className="rounded-2xl border border-wafa-primary/30 bg-wafa-primary p-10 text-center sm:p-14 lg:p-20">
          <h2 className="font-heading text-3xl font-semibold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Ready when you are.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-white/90 lg:text-base">
            Book a thirty-minute call. We'll turn what you're carrying today into a one-page plan.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/contact"
              data-testid="closing-cta-primary"
              className="inline-flex items-center gap-2 rounded-md bg-white px-6 py-3 text-sm font-semibold text-wafa-deep transition-colors duration-200 hover:bg-wafa-cream"
            >
              Book a Free Scoping Call
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/tools"
              data-testid="closing-cta-secondary"
              className="inline-flex items-center gap-2 rounded-md border border-white/40 px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10"
            >
              Try our tools first
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
